import { Tooltip } from "@mui/material";
import { COLORS, TYPOGRAPHY } from "../constants/color";

const CustomTooltip = ({ title, children, placement = "top" }) => {
  return (
    <Tooltip
      arrow
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "#ffffff",
            color: COLORS.PRIMARY,
            boxShadow: "0px 4px 12px rgba(0,0,0,0.12)",
            borderRadius: 1,
            px: 1.2,
            py: 0.8,
            ...TYPOGRAPHY.BODY_SMALL,
          },
        },
        arrow: {
          sx: {
            color: "#ffffff",
          },
        },
      }}
      title={title}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
